module.exports = __webpack_public_path__ + "static/media/do.pictogram.24945852.svg";